import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/** Read a single key from public.site_content (key/value text store). */
export function useSiteSetting(key: string, fallback: string): string {
  const [value, setValue] = useState<string>(fallback);
  useEffect(() => {
    let alive = true;
    supabase
      .from("site_content")
      .select("value")
      .eq("key", key)
      .maybeSingle()
      .then(({ data }) => {
        if (alive && data?.value) setValue(data.value);
      });
    return () => { alive = false; };
  }, [key]);
  return value;
}